import { createFileRoute } from '@tanstack/react-router'

import { AiRiskScoreSettings } from '@/widgets/ai-risk-score-settings'

export const Route = createFileRoute('/_app/settings/risk-scoring')({
  component: RouteComponent,
})

export const RiskScoringSettingsRoute = Route

function RouteComponent() {
  return <AiRiskScoreSettings />
}
